import React from "react";
import DashboardShell from "@/components/DashboardShell";
import { Palette } from "lucide-react";

export default function AdminBranding() {
  return (
    <DashboardShell>
      <div data-testid="admin-branding">
        <div className="overline text-sg-gold-deep">PLATFORM BRANDING</div>
        <h1 className="font-display text-4xl text-sg-navy mt-1">INPropPortal <span className="font-serif-italic text-sg-gold-deep">brand</span></h1>
        <p className="text-sg-mute mt-2 max-w-2xl">
          Owner brand controls live here. Agent-level branding (per agent accent &amp; logo) is configured by each agent in their own dashboard.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white border border-sg-line rounded-2xl p-6">
            <div className="overline text-sg-gold-deep">LOGO</div>
            <div className="mt-4 bg-sg-navy rounded-xl p-8 flex items-center justify-center">
              <img src="/inpropportal-logo.png" alt="INPropPortal.com" className="h-16" />
            </div>
            <p className="mt-3 text-xs text-sg-mute font-mono">/inpropportal-logo.png · 200×100 · transparent PNG</p>
          </div>

          <div className="bg-white border border-sg-line rounded-2xl p-6">
            <div className="overline text-sg-gold-deep">PALETTE</div>
            <div className="mt-4 space-y-3">
              {[
                { name: "Navy", hex: "#0B1B33", color: "#0B1B33" },
                { name: "Navy Deep", hex: "#061026", color: "#061026" },
                { name: "Cream Paper", hex: "#FBF6E9", color: "#FBF6E9" },
                { name: "Champagne Gold", hex: "#C9A24A", color: "#C9A24A" },
                { name: "Gold Deep", hex: "#A98532", color: "#A98532" },
              ].map((c) => (
                <div key={c.hex} className="flex items-center gap-3" data-testid={`palette-${c.hex}`}>
                  <div className="w-8 h-8 rounded-md border border-sg-line" style={{ background: c.color }} />
                  <div className="flex-1">
                    <div className="text-sm text-sg-navy">{c.name}</div>
                    <div className="text-xs font-mono text-sg-mute">{c.hex}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white border border-sg-line rounded-2xl p-6 md:col-span-2">
            <div className="overline text-sg-gold-deep">TYPOGRAPHY</div>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <div className="font-display text-3xl text-sg-navy">Playfair Display</div>
                <div className="text-xs text-sg-mute font-mono mt-1">Headlines · serif italic accents</div>
              </div>
              <div>
                <div className="text-2xl text-sg-navy">Inter</div>
                <div className="text-xs text-sg-mute font-mono mt-1">Body · UI</div>
              </div>
              <div>
                <div className="font-mono text-xl text-sg-navy">JetBrains Mono</div>
                <div className="text-xs text-sg-mute font-mono mt-1">Numerics · meta · IDs</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
